module.exports = __webpack_public_path__ + "static/media/Search.1047e218.svg";